import DamageRequest from './DamageRequest';

export default DamageRequest;
